export const LEAVE_REQUEST_WORKFLOW_SELECTED_TYPES_LOAD =
  'LEAVE_REQUEST_WORKFLOW_SELECTED_TYPES_LOAD'
export const LEAVE_REQUEST_WORKFLOW_SELECTED_TYPES_LOAD_PENDING =
  'LEAVE_REQUEST_WORKFLOW_SELECTED_TYPES_LOAD_PENDING'
export const LEAVE_REQUEST_WORKFLOW_SELECTED_TYPES_LOAD_FULFILLED =
  'LEAVE_REQUEST_WORKFLOW_SELECTED_TYPES_LOAD_FULFILLED'
export const LEAVE_REQUEST_WORKFLOW_SELECTED_TYPES_LOAD_REJECTED =
  'LEAVE_REQUEST_WORKFLOW_SELECTED_TYPES_LOAD_REJECTED'
